import { request } from "../utils/request.js"

export const organization_addNew = (pojo, args) => request({
    url: 'organization/addNew',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    showSuccessMessage: true,
    ...args
})

export const organization_update = (pojo, args) => request({
    url: 'organization/update',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    showSuccessMessage: true,
    ...args
})

export const organization_deleteById = (id, args) => request({
    url: 'organization/deleteById',
    method: 'GET',
    params: { id },
    showFailMessage: true,
    showSuccessMessage: true,
    ...args
})

export const organization_changeFrozenStatus = (id, args) => request({
    url: 'organization/changeFrozenStatus',
    method: 'GET',
    params: { id },
    showFailMessage: true,
    showSuccessMessage: true,
    ...args
})

export const organization_flushCache = (args) => request({
    url: 'organization/flushCache',
    method: 'GET',
    showFailMessage: true,
    showSuccessMessage: true,
    ...args
})

export const organization_findAllTree = (args) => request({
    url: 'organization/findAllTree',
    method: 'GET',
    showFailMessage: true,
    ...args
})

export const organization_findUnFrozenTree = (args) => request({
    url: 'organization/findUnFrozenTree',
    method: 'GET',
    showFailMessage: true,
    ...args
})

export const organization_findUnfrozenList = (args) => request({
    url: 'organization/findUnfrozenList',
    method: 'GET',
    showFailMessage: true,
    ...args
})

export const organization_findById = (id, args) => request({
    url: 'organization/findById',
    method: 'GET',
    params: { id },
    showFailMessage: true,
    ...args
})

export const organization_findTopNode = (args) => request({
    url: 'organization/findTopNode',
    method: 'GET',
    showFailMessage: true,
    ...args
})


// WEBPACK FOOTER //
// ./src/api/organization.js